export default __webpack_public_path__ + "static/media/boy-jumping-into-pool.a610b784.png";